import { render, staticRenderFns } from "./CodeTransferComplete.vue?vue&type=template&id=3d85a472&scoped=true"
import script from "./CodeTransferComplete.vue?vue&type=script&lang=js"
export * from "./CodeTransferComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d85a472",
  null
  
)

export default component.exports